import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14a557ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "settings" }
const _hoisted_2 = { class: "btn-wrap" }

import {ref} from "vue";
import {queryMessageSettingApi, saveMessageSettingApi} from "@/api/message";
import {ElMessage} from "element-plus";

interface props {
  tabList: any[] // 消息设置选项卡列表
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Settings',
  props: {
    tabList: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const {tabList} = props;

const emits = __emit;

/**
 * 接受方式
 */
const acceptList = [
  //   站内信不能取消，默认选中
  {value: 1, label: '站内信', name: 'znx'},
  // {value: 2, label: '短信', name: 'sms'},
  {value: 3, label: '邮件', name: 'email'},
  {value: 4, label: '公众号', name: 'wechat'},
];

/**
 * 表格数据
 */
const tableData = ref<any[]>(tabList.map(v => ({
  type: v.tips,
  typeId: v.id,
  accept: [],
  acceptList
})));

/**
 * 取消保存
 */
const cancelSave = () => {
  emits('close');
};

/**
 * 保存
 * 数据格式：[{"id": 1,"user_id": 3,"type": "1","znx": 1,"sms": 0,"email": 0,"wechat": 0}]
 */
const save = async () => {
  let data = tableData.value.map(v => {
    let accpet:any = {}
    v.acceptList.forEach((v1: any) => {
      accpet[v1.name] = v.accept.includes(v1.name) ? 1 : 0;
    })
    return {
      id: v.id,
      user_id: v.userId,
      type: v.typeId,
      ...accpet
    }
  })
  // 调用保存接口
  let res = await saveMessageSettingApi({data});
  ElMessage.success('保存成功');
  cancelSave();
};

/**
 * 获取设置列表
 */
const getSettingList = async () => {
  let data:any = await queryMessageSettingApi();
  data && data.length && data.forEach((v: any) => {
    if (+v.znx === 0){
      v.znx = 1
    }
    let item = tableData.value.find(vv => vv.typeId === v.type);
    item.id = v.id;
    item.userId = v.user_id;
    for (let vKey in v) {
      const vVal = v[vKey];
      let acceptItem = item.acceptList.filter((vv:any) => vv.name === vKey);
      if (acceptItem.length){
        acceptItem.forEach((vvv:any) => {
          if (vVal){
            item.accept.push(vvv.name)
          }
        })
      }
    }
  })
}

getSettingList();

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (tableData.value.length)
      ? (_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          data: tableData.value,
          style: {"width":"100%"},
          border: "",
          "header-row-class-name": "header"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "type",
              label: "消息类型",
              width: 460
            }),
            _createVNode(_component_el_table_column, {
              label: "接受方式",
              width: 460
            }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: row.accept,
                  "onUpdate:modelValue": ($event: any) => ((row.accept) = $event)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.acceptList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: item.value,
                        label: item.name,
                        disabled: item.name === 'znx'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "disabled"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, { onClick: cancelSave }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: save
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})